import React from 'react';
import cmLogo from '../images/chaimate-logo-main.svg';

export default function ChaimateClubLanding() {
  return (
    <div style={{
      position: 'fixed', inset: 0,
      background: 'linear-gradient(160deg, #0a0a12 0%, #111127 50%, #0a0a12 100%)',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      overflow: 'hidden',
    }}>
      {/* Subtle glow */}
      <div style={{
        position: 'absolute', top: '30%', left: '50%', transform: 'translate(-50%, -50%)',
        width: 400, height: 400, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(99,102,241,0.12) 0%, transparent 70%)',
        filter: 'blur(60px)', pointerEvents: 'none',
      }} />

      <div style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
        <img
          src={cmLogo}
          alt="Chaimate"
          style={{ width: 80, height: 80, marginBottom: 32, borderRadius: 20 }}
        />

        <h1 style={{
          fontSize: 36, fontWeight: 700, color: '#ffffff',
          letterSpacing: '-0.02em', lineHeight: 1.2,
          margin: '0 0 12px',
        }}>
          Welcome to
          <br />
          <span style={{
            background: 'linear-gradient(135deg, #6366f1, #a855f7, #ec4899)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}>
            Chaimate Club
          </span>
        </h1>

        <p style={{
          fontSize: 15, color: 'rgba(255,255,255,0.5)',
          lineHeight: 1.6, maxWidth: 320, margin: '0 auto 40px',
        }}>
          Conversational Intelligence for your business
        </p>

      </div>
    </div>
  );
}
